import { useCallback, useRef } from 'react';
const useDebounce = (callback, delay) => {
    const callbackRef = useRef(callback);
    const timerRef = useRef(undefined);
    return useCallback((...args) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            callbackRef.current(...args);
        }, delay);
    }, []);
};
export default useDebounce;
